<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import PageHeader from 'dashboard/components-next/polaris/cards/PageHeader.vue';

const props = defineProps({
  headerTitle: { type: String, default: '' },
  keepAlive: { type: Boolean, default: true },
});

const { t } = useI18n();

// eslint-disable-next-line @intlify/vue-i18n/no-dynamic-keys
const title = computed(() => (props.headerTitle ? t(props.headerTitle) : ''));
</script>

<!-- The frame of the settings pages that live under a section of their own (new inbox, macro editor, team steps):
     the kit's PageHeader on top, still, and the page scrolling under it. No Back button (D-G2): the Topbar
     breadcrumb leads back. -->
<template>
  <div
    class="flex h-full min-h-0 w-full flex-col bg-n-surface-1 text-polaris-foreground"
  >
    <PageHeader v-if="title" :title="title" />
    <div class="min-h-0 flex-1 overflow-auto">
      <router-view v-slot="{ Component }">
        <component :is="Component" v-if="!keepAlive" :key="$route.fullPath" />
        <keep-alive v-else>
          <component :is="Component" :key="$route.fullPath" />
        </keep-alive>
      </router-view>
    </div>
  </div>
</template>
